import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import toastr from "toastr";
import Sidebar from "./Sidebar";
import Container from "react-bootstrap/Container";
import { Row, Form } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Navbar from "./Navbar";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

export default function OrderList() {
  const authToken = localStorage.getItem("disToken");
  const [orderDetails, setOrderDetails] = useState([]);
  useEffect(() => {
    getOrderDetails();
  }, [authToken]);

  async function getOrderDetails() {
    try {
      const response = await axios.get(
        `http://api.meddaily.in/distributor_order`,
        {
          headers: {
            token: `${authToken}`,
          },
        }
      );

      if (response.status === 200) {
        setOrderDetails(response?.data?.data);
        console.log("response", response.data.data);
      }
    } catch (err) {
      toastr.error(err?.response?.data?.message);
      console.log(err);
    }
  }
  const MAX_DESCRIPTION_LENGTH = 50;

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Sidebar />
          <div className="layout-page">
            <Navbar />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                  <div className="card mb-12">
                    <div className="card-header d-flex justify-content-between align-items-center"></div>

                    <hr className="my-0" />
                    <div className="card-body">
                      <div className="container-xxl flex-grow-1 container-p-y">
                        <div className="row">
                          <div className="card">
                            <h5 className="card-header float-start">
                              Order Table
                            </h5>
                            <div className="table-responsive text-nowrap">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>OrderId</th>
                                    <th>Order Status</th>
                                    <th>Retailer Name</th>
                                    <th>Payment Type</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                {orderDetails &&
                                  orderDetails.length > 0 &&
                                  orderDetails.map((item, i) => {
                                    return (
                                      <tbody>
                                        <tr>
                                          <td>{item.order_id}</td>
                                          <td>
                                            {item.order_status === 4
                                              ? "Order Placed"
                                              : item.order_status === 1
                                              ? "Order Shipped"
                                              : item.order_status === 3
                                              ? "Order Delivered"
                                              : item.order_status === 0
                                              ? "Cancelled"
                                              : ""}
                                          </td>
                                          <td>{item.retailer_name || "NA"}</td>
                                          <td>
                                            {item.payment_type === 1 && "COD"}
                                            {item.payment_type === 2 &&
                                              "Pay On Credit"}
                                          </td>
                                          <td>
                                            <div className="dropdown">
                                              <Link
                                                className="dropdown-item"
                                                to={{
                                                  pathname: "/createorder",
                                                  state: { id: item?.order_id },
                                                }}
                                              >
                                                {" "}
                                                View Full Details
                                              </Link>
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    );
                                  })}
                              </table>
                            </div>
                          </div>
                        </div>

                        <div className="content-backdrop fade"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="content-backdrop fade"></div>
              </div>
            </div>
          </div>

          <div className="layout-overlay layout-menu-toggle"></div>
        </div>
      </div>
    </>
  );
}
